import { Box, IconButton, Stack, Typography, useTheme } from '@chronosphereio/chrono-ui';
import { useMountEffect } from '@react-hookz/web';
import { Close as CloseIcon } from 'mdi-material-ui';
import { ThresholdColorPicker } from '@/plugin-editor-components/components/ThresholdsEditor/ThresholdColorPicker';
import { OverrideOptionComponent } from '../types';

export const OverrideColorPicker: OverrideOptionComponent<string | undefined> = ({
  onChange,
  value,
  title,
  onRemove,
}) => {
  const { theme } = useTheme();
  const fallbackColor = theme.palette.designSystem.blue[600];

  useMountEffect(() => {
    if (value === undefined) {
      onChange(fallbackColor);
    }
  });

  return (
    <Stack direction="row" alignItems="center">
      <Box flexGrow={0}>
        <Typography variant="subtitle1">{title}</Typography>
      </Box>

      <Box flexGrow={1}></Box>

      <Box flexGrow={0}>
        <ThresholdColorPicker label="" color={value ?? fallbackColor} onColorChange={onChange} />
      </Box>

      <Box flexGrow={0}>
        <IconButton size="small" onClick={onRemove}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};
